<div class="quantity {{mode ? '-mode-'+mode : '-mode-mini'}}{{size ? ' -size-'+size : ''}}"
    [ngClass]="{'is-disabled': disabled}">
    <div class="quantity__inner">

        <div class="quantity__col -for-decrement" [ngClass]="{'-mask-buttons': maskDecrementButtons}">

            <shared-circle-btn [ngClass]="{'-mask': maskDecrementButtons}" [size]="size"
                class="quantity__btn -for-remove" (onClick)="handleRemove($event)" icon="remove-for-circle"
                iconHover="removing-for-circle" *ngIf="showRemoveButton" [feel]="btnNegativeFeel">
            </shared-circle-btn>

            <shared-circle-btn [ngClass]="{'-mask': maskDecrementButtons}" [size]="size"
                class="quantity__btn -for-decrement" (onClick)="handleDecrement($event)" icon="subtract"
                [feel]="btnNegativeFeel" *ngIf="showDecrementButton" [disabled]="isDecrementButtonDisabled">
            </shared-circle-btn>

        </div>

        <div class="quantity__col -for-counter">
            <label class="quantity__label">
                {{quantity | leadingZero}}
            </label>
        </div>

        <div class="quantity__col -for-increment">

            <shared-circle-btn [size]="size" class="quantity__btn -for-increment" (onClick)="handleIncrement($event)"
                icon="add" [feel]="btnPostiveFeel" [disabled]="isIncrementButtonDisabled">
            </shared-circle-btn>

        </div>

    </div>
</div>
